import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { loadAgreementDocuments, loadAppliedApplicationsJobDetails } from "../../requests/applicationApplied";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { EmptyList, Loading } from "@qjumpers/common-ui";
import { useHistory } from "react-router-dom";
import { downloadDocument, updateDocumentStatus } from "../../requests/agreementdocuments";
import { errorState } from "../../recoil/error/atom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { downloadFileFromBase64Data, downloadZipFromBase64Data, getFileExtension } from "../../utils/documentsHelper";
import { toggleHandsetColumnButton } from "../../utils/uiHelper";
import { Alert, Button, Spinner } from "react-bootstrap";
import { downloadAllDocuments } from "../../requests/documents";
import { candidateId as candidateIdFromAtom } from "../../recoil/candidate/atom";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry } from "ag-grid-community";
import { AllCommunityModule } from "ag-grid-community";
import { ClientSideRowModelModule } from "ag-grid-community";
import { NoteFormWrapper } from "../commonWrapper/noteFormWrapper";
import { documentInViewState } from "../../recoil/agreementdocuments/atom";
import { noteTypesData } from "../../recoil/notetypes/atom";
// Register AG Grid modules (once)
ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule]);

const documentStatusType = ["", "Not Opened", "Reviewed", "Completed"];
const MOBILE_MEDIA_QUERY = "(max-width: 767px)";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia?.(MOBILE_MEDIA_QUERY).matches ?? false);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (event) => setIsMobile(event.matches);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }, []);

  return isMobile;
};

const AgreementDocumentsList = () => {
  const params = useParams();
  const { t } = useTranslation();
  const history = useHistory();
  const popError = useSetRecoilState(errorState);
  const viewAgreementDocument = useSetRecoilState(documentInViewState);
  const [pageInfo, setPageInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloadingDocuments, setIsDownloadingDocuments] = useState(false);
  const [allSectionsSigned, setAllSectionsSigned] = useState(false);
  const [documents, setDocuments] = useState();
  const [pageSize, setPageSize] = useState(10);
  const notesTypes = useRecoilValue(noteTypesData);
  const candidateIdAtom = useRecoilValue(candidateIdFromAtom);
  const isMobile = useIsMobile();
  const loadData = () => {
    loadAppliedApplicationsJobDetails(params.applicationId).then((result) => {
      if (result.data) {
        const response = result.data;

        const jobDetails = {
          jobTitle: get(response, "job.title", ""),
          jobId: get(response, "job.id", ""),
          jobLocation: `${response.address?.placeName ? get(response.address, "placeName", "") : ""} ${get(
            response.address,
            "region",
            ""
          )}`,
          jobReferenceId: response.job.jobReferenceId,
          organisationId: response.job.organisationId,
        };

        let listInfo = {
          candidateId: response.candidateId,
          applicationId: params.applicationId,
          jobDetails: jobDetails,
        };
        setPageInfo(listInfo);

        loadAgreementDocuments(listInfo.candidateId, listInfo.jobDetails.jobId, listInfo.jobDetails.organisationId)
          .then((result) => {
            if (result.data) {
              setDocuments(result.data);
            }

            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    });
  };

  useEffect(() => {
    localStorage.removeItem("allSectionsSigned");
    loadData();
    const allSectionsSignedLS = localStorage.getItem("allSectionsSigned");
    if (allSectionsSignedLS == "true") {
      setAllSectionsSigned(true);
    }
  }, [candidateIdAtom]);

  const getDocumentReceivedDate = (cell, row) => t("ShortDateValue", { date: row.modifiedDate });
  const getDocumentExpiryDate = (cell, row) => t("ShortDateValue", { date: row.expiryDate });

  const getDocumentStatus = (cell, row) => {
    switch (row.status) {
      case 0:
      case 1:
        return documentStatusType[row.status];
      case 2:
        if (allSectionsSigned === true) {
          return (
            <div>
              <span>{documentStatusType[3]}</span> <span>{"("}</span>
              <span>{t("ShortDateValue", { date: row.documentStatusUpdatedDate })}</span>
              <span>{")"}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span>{documentStatusType[row.status]}</span> <span>{"("}</span>
              <span>{t("ShortDateValue", { date: row.documentStatusUpdatedDate })}</span>
              <span>{")"}</span>
            </div>
          );
        }
      case 3:
        return (
          <div>
            <span>{documentStatusType[row.status]}</span> <span>{"("}</span>
            <span>{t("ShortDateValue", { date: row.documentStatusUpdatedDate })}</span>
            <span>{")"}</span>
          </div>
        );
      default:
        return "";
    }
  };

  const redirectToSignDocument = (document, status) => {
    const { candidateId, applicationId, jobDetails } = pageInfo;
    let previewDocument = {
      candidateId,
      applicationId,
      document,
      jobDetails,
      status,
    };
    viewAgreementDocument(previewDocument);
    // this.props.viewAgreementDocument(previewDocument);

    history.push(`/application/previewdocument/${document.id}`);
  };

  const openAgreementDocument = (document, data) => {
    if (document.status !== 2 && document.status !== 3 && document.status !== 0) {
      updateDocumentStatus(data, document.id).then(() => {
        redirectToSignDocument(document, 2);
      });
    } else {
      redirectToSignDocument(document, document.status);
    }
  };

  const reviewDocument = (document) => {
    const { candidateId, jobDetails } = pageInfo;
    const data = {
      organisationId: jobDetails.organisationId,
      updateToStatus: 2,
      candidateId: candidateId,
      jobId: jobDetails.jobId,
      isTouchSignatureUI: false,
      signatureContent: null,
      currentTimeStamp: null,
    };

    if (document.name === "KS2 - Kiwisaver Deduction Form" && document.status !== 3) {
      popError([
        {
          type: "info",
          title: t("AgreementDocuments.KS2.Title"),
          message: t("AgreementDocuments.KS2.OptOutMessage"),
          confirmBtnText: t("Action.Close"),
          showCancel: false,
          confirmBtnBsStyle: "success",
          onConfirm: () => {
            openAgreementDocument(document, data);
          },
        },
      ]);
    } else if (document.name === "KS10 - Kiwisaver Opt out Request" && document.status !== 3) {
      popError([
        {
          type: "info",
          title: t("AgreementDocuments.KS10.Title"),
          message: t("AgreementDocuments.KS10.OptOutMessage"),
          confirmBtnText: t("Action.Close"),
          showCancel: false,
          confirmBtnBsStyle: "success",
          onConfirm: () => {
            openAgreementDocument(document, data);
          },
        },
      ]);
    } else {
      openAgreementDocument(document, data);
    }
  };

  const openDocument = (object) => {
    const { candidateId } = pageInfo;

    // Every document (including job descriptions) is read through the API, the S3 bucket is private.
    return downloadDocument(candidateId, object.id).then((response) => {
      if (response.data?.pdfContent && !response.data.isError) {
        downloadFileFromBase64Data(response.data.pdfContent, object.name, getFileExtension(object.url));
      }
    });
  };

  // On phones only the name (with status underneath) and actions are shown, so nothing needs horizontal scrolling.
  const mobileColumnDefs = [
    {
      headerName: "Document",
      field: "name",
      flex: 1,
      minWidth: 120,
      wrapText: true,
      autoHeight: true,
      cellStyle: { lineHeight: "1.4", paddingTop: "8px", paddingBottom: "8px" },
      cellRenderer: (p) => (
        <div>
          <div style={{ fontWeight: 500, wordBreak: "break-word" }}>{p.data.name}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>{getDocumentStatus(null, p.data)}</div>
        </div>
      ),
    },
    {
      headerName: "",
      cellRenderer: (p) => getActionButton(null, p.data),
      width: 150,
      suppressSizeToFit: true,
      cellStyle: { paddingLeft: "0px", paddingRight: "4px", display: "flex", alignItems: "center" },
    },
  ];

  // Build ag-Grid column definitions
  const columnDefs = [
    { headerName: "Document Name", field: "name", flex: 1, minWidth: 220 },
    {
      headerName: "Received Date",
      valueGetter: (p) => getDocumentReceivedDate(null, p.data),
      width: 150,
    },
    {
      headerName: "Expiry Date",
      valueGetter: (p) => getDocumentExpiryDate(null, p.data),
      width: 150,
    },
    {
      headerName: "Status",
      cellRenderer: (p) => getDocumentStatus(null, p.data),
      width: 180,
    },
    {
      headerName: "Actions",
      cellRenderer: (p) => getActionButton(null, p.data),
      width: 260,
      suppressSizeToFit: true,
    },
    { headerName: "ID", field: "id", hide: true },
  ];

  const getActionButton = (cell, row) => {
    const { jobDetails, candidateId } = pageInfo;
    return (
      <div style={{ textAlign: "right", whiteSpace: "nowrap", width: "100%" }}>
        <Button variant="outline-secondary" disabled={row.status < 1} size="sm" onClick={() => reviewDocument(row)}>
          {t("Action.View")}
        </Button>
        <DownloadDocumentButton onDownload={() => openDocument(row)} />
        <span style={{ display: "inline-block" }}>
          <NoteFormWrapper
            hasCommunicationRights={true}
            hasManageRights={true}
            supportATSOperations={true}
            relatedObject={row}
            noteTypes={notesTypes}
            candidateId={candidateId}
            jobId={jobDetails.jobId}
            initialValues={{
              note: {
                entityType: "employmentdocuments",
                entityId: row.id,
              },
            }}
            showNotesButton={true}
          />
        </span>
      </div>
    );
  };

  const downloadAllDocumentsForJob = (candidateId, jobId) => {
    setIsDownloadingDocuments(true);
    downloadAllDocuments(candidateId, jobId)
      .then((response) => {
        const fileName = "Employment Agreement and Offer Documents.zip";
        downloadZipFromBase64Data(response.data.pdfContent, fileName);
      })
      .catch(() => {})
      .finally(() => setIsDownloadingDocuments(false));
  };

  const { jobDetails, candidateId } = pageInfo;
  const documentStatus = documents && documents.length > 0 && documents.filter((el) => el.status < 3 && el.status > 0);

  return (
    <div className="dashboard-list--header">
      {documentStatus?.length > 0 && (
        <div className="row">
          <Alert variant="warning">
            <center>
              <strong>{t("AgreementDocuments.pendingSignatureErrorMessage")}</strong>
            </center>
          </Alert>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-sm-8 col-md-8">
          <h2>Employment Agreement and Offer Documents</h2>
          <div>
            {" "}
            {`Job Title: ${get(jobDetails, "jobTitle", "")} | Location : ${get(
              jobDetails,
              "jobLocation",
              ""
            )} | Job ID : ${get(jobDetails, "jobReferenceId", "")}`}
          </div>
        </div>
      </div>
      <Loading className="loading-component" isLoading={isLoading}>
        {documents && documents.length > 0 ? (
          <div style={{ width: "100%" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div>
                <label style={{ fontSize: 12 }}>
                  Rows:&nbsp;
                  <select
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                    style={{ padding: "2px 4px" }}>
                    {[10, 20, 30, 40, 50].map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <Button
                disabled={isDownloadingDocuments}
                variant="info"
                size="sm"
                onClick={() => downloadAllDocumentsForJob(candidateId, jobDetails?.jobId)}>
                {isDownloadingDocuments && <Spinner as="span" animation="border" size="sm" style={{ marginRight: "6px" }} />}
                Download All
              </Button>
            </div>
            <div className="ag-theme-alpine agreement-documents-grid" style={{ width: "100%" }}>
              <AgGridReact
                key={isMobile ? "mobile" : "desktop"}
                rowData={documents}
                columnDefs={isMobile ? mobileColumnDefs : columnDefs}
                pagination
                paginationPageSize={pageSize}
                paginationPageSizeSelector={false}
                suppressCellFocus
                domLayout="autoHeight"
                getRowId={(p) => p.data.id}
                onGridReady={(params) => params.api.sizeColumnsToFit()}
                onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
              />
            </div>
          </div>
        ) : (
          <div style={{ marginTop: "30px" }}>
            <EmptyList />
          </div>
        )}
      </Loading>
    </div>
  );
};

// Keeps its own loading state so only the clicked row shows a spinner (ag-Grid cells don't re-render on parent state changes).
const DownloadDocumentButton = ({ onDownload }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = () => {
    setIsDownloading(true);
    onDownload()
      .catch(() => {})
      .finally(() => setIsDownloading(false));
  };

  return (
    <Button variant="outline-secondary" data-testid="downloadTest" size="sm" disabled={isDownloading} onClick={download}>
      {isDownloading ? (
        <Spinner as="span" animation="border" size="sm" />
      ) : (
        <span className="qjicon-down" style={{ marginRight: "0px" }} />
      )}
    </Button>
  );
};

export default AgreementDocumentsList;
